import React from 'react';

import ReserveDate from "components/SearchComponents/ReserveDate";
import RoomQuantity from "components/SearchComponents/RoomQuantity";
import Offers from "components/SearchComponents/Offers"
import SearchLocation from "components/SearchComponents/SearchLocation";

import {
    changeDatesHotelAction,
    changeLocationsHotelAction,
    changeOfferHotelAction
} from "contexts/reducers/hotels/actions";
import { useApp } from "contexts/AppContext";

export const FormSearchHotels = () => {

    const { hotelState, hotelDispatch } = useApp()
    const { offersHotel, locationSearchHotel, datesSearchHotel  } = hotelState

    const searchLocation = (local) => {
        hotelDispatch(changeLocationsHotelAction(local))
    }

    const changeOffers = (offers) => {
        hotelDispatch(changeOfferHotelAction(offers))
    }

    const changeDates = (dates) => {
        hotelDispatch(changeDatesHotelAction(dates))
    }

    return (
        <div className="box-search">
            <SearchLocation
                placeholder="Digite aqui uma cidade"
                location={ locationSearchHotel }
                onChange={searchLocation}
            />

            <ReserveDate
                 rangeDates={datesSearchHotel}
                 onChange={changeDates}
                 label="Selecione as datas para o seu hotel"
                 labelStartDate="Check-in"
                 labelEndDate="Check-out"
            />

            <RoomQuantity />

            <Offers
                offers={offersHotel}
                changeOffers={changeOffers}
            />
        </div>
    )
}
